module.exports = __webpack_public_path__ + "static/media/1_SOGCHeader-fr.42a5898b.png";